/* ============================================================
   DM KONFIGURATOR — Addition (ADD) für Gleitsicht und Bifokal
   Diving Mask · Nachtrag zu dm-konfigurator.js
   ------------------------------------------------------------
   Warum eine eigene Datei:
   dm-konfigurator.js ist gewachsen und wird an mehreren Stellen
   gepflegt. Dieser Nachtrag hängt sich additiv an die Prototyp-
   Methoden des Custom Elements, statt die große Datei anzufassen.
   Wird dort etwas umbenannt, meldet sich dieser Nachtrag in der
   Konsole — deshalb die Prüfungen unten.

   Fachlich:
   Auf jedem Brillenpass steht für Gleitsicht und Bifokal neben
   Sphäre, Zylinder und Achse ein weiterer Wert: die Addition,
   meist als „ADD" oder „Nah" bezeichnet. Sie sagt, wieviel
   Stärke unten im Lesebereich dazukommt. Ohne sie lässt sich
   kein Nahteil schleifen — sie ist Pflichtangabe, kein Extra.
   Bei Einstärke entfällt sie, auch bei „Einstärke Nähe": dort
   gibt der Kunde den Nahwert direkt als Sphäre an.

   Wertebereich nach Vorgabe der Werkstatt: +0,75 bis +3,00 in
   0,25er-Schritten, je Auge getrennt wählbar.
   ============================================================ */

(function () {
  'use strict';

  var ADDITION = (function () {
    var a = [];
    for (var v = 0.75; v <= 3.001; v += 0.25) a.push(Number(v.toFixed(2)));
    return a;
  })();

  /* Dieselben Listen wie im Hauptskript. Sie stehen dort im
     Modulverschluss und sind von außen nicht erreichbar. */
  function reihe(von, bis, schritt) {
    var werte = [];
    var n = Math.round((von - bis) / schritt);
    for (var i = 0; i <= n; i++) werte.push(+(von - i * schritt).toFixed(2));
    return werte;
  }
  var SPHAERE = reihe(8, -12, 0.25);
  var ZYLINDER = reihe(0, -6, 0.25);
  var ACHSE = (function () {
    var a = [];
    for (var i = 0; i <= 180; i += 1) a.push(i);
    return a;
  })();

  function dioptrie(n) {
    if (n === 0) return '0,00';
    var s = Math.abs(n).toFixed(2).replace('.', ',');
    return (n > 0 ? '+' : '−') + s;
  }

  /* ASCII-Schreibweise der alten App, wie die Werkstatt sie liest. */
  function altZahl(n) {
    var z = Number(n) || 0;
    if (z === 0) return '0.00';
    return (z > 0 ? '+' : '-') + Math.abs(z).toFixed(2);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Die Beschriftungen liegen noch nicht in locales/*.json. Damit der
     Nachtrag ohne Sprachdatei auskommt, bringt er sie mit und weicht
     auf das Datenpaket aus, sobald die Schlüssel dort gepflegt sind. */
  var TEXTE = {
    de: {
      add: 'Addition (ADD)',
      add_note: 'Die Addition steht auf Ihrem Brillenpass in der Spalte „ADD“ oder „Nah“. ' +
                'Sie sagt, wieviel Stärke im Lesebereich dazukommt — ohne sie können wir kein ' +
                'Gleitsicht- oder Bifokalglas schleifen. Steht dort nichts, fragen Sie kurz bei ' +
                'Ihrem Optiker nach.',
      p_add: 'ADD'
    },
    en: {
      add: 'Addition (ADD)',
      add_note: 'Your prescription shows the addition in the column “ADD” or “Near”. It says how ' +
                'much power is added in the reading zone — without it we cannot grind a progressive ' +
                'or bifocal lens. If it is missing, please ask your optician.',
      p_add: 'ADD'
    }
  };

  function text(self, schluessel) {
    var t = self.t || {};
    var wert = t[schluessel];
    /* Shopify liefert bei fehlendem Schluessel einen Hinweistext
       statt einer leeren Zeichenkette - der darf nicht in die
       Oberflaeche. */
    if (wert && String(wert).toLowerCase().indexOf('translation missing') === -1) return wert;
    var sprache = (document.documentElement.lang || 'de').slice(0, 2).toLowerCase();
    var satz = TEXTE[sprache] || TEXTE.de;
    return satz[schluessel];
  }

  function patchen(Ctor) {
    if (!Ctor || !Ctor.prototype) return;
    var P = Ctor.prototype;
    if (P._dmAddAktiv) return;

    var noetig = ['_auge', '_select', '_weiterPruefen', '_augeText', '_rezeptFelder', '_werkstattWerte', '_schritt_werte'];
    var fehlend = noetig.filter(function (m) { return typeof P[m] !== 'function'; });
    if (fehlend.length) {
      console.warn('[dm-konfigurator-add] Nicht angehaengt, folgende Methoden fehlen:', fehlend.join(', '));
      return;
    }
    P._dmAddAktiv = true;

    /* ---------- Braucht diese Verglasung eine Addition? ----------
       Geprueft wird ueber Handle UND Optionswert, damit die Erkennung
       in jeder Sprache greift: auf der deutschen Storefront heisst
       \"Progressive\" eben \"Gleitsicht\". */
    P._brauchtAdd = function () {
      var art = this.auswahl && this.auswahl.art;
      if (!art) return false;
      var kennung = ((art.handle || '') + ' ' + (art.optionswert || '') + ' ' + (art.titel || '')).toLowerCase();
      return kennung.indexOf('gleitsicht') !== -1 ||
             kennung.indexOf('progressive') !== -1 ||
             kennung.indexOf('bifokal') !== -1 ||
             kennung.indexOf('bifocal') !== -1;
    };

    /* ---------- Augenblock mit zusaetzlichem ADD-Feld ---------- */
    var augeAlt = P._auge;
    P._auge = function (seite, beschriftung, kuerzel) {
      var html = augeAlt.call(this, seite, beschriftung, kuerzel);
      if (!this._brauchtAdd()) return html;

      var w = this.auswahl[seite] || {};
      var feld = '' +
        '<div>' +
          '<label class="dm-k__label" for="dm-' + seite + '-add">' + esc(text(this, 'add')) + '</label>' +
          this._select('dm-' + seite + '-add', seite + '.add', ADDITION, w.add, dioptrie, this.t.choose) +
        '</div>';

      /* Vor das schliessende </div> der Feldgruppe haengen. */
      var marke = '</div>' + '</div>';
      var pos = html.lastIndexOf(marke);
      if (pos === -1) return html;
      return html.slice(0, pos) + feld + html.slice(pos);
    };

    /* ---------- Hinweis unter den Augen ---------- */
    var werteAlt = P._schritt_werte;
    P._schritt_werte = function () {
      var html = werteAlt.call(this);
      if (!this._brauchtAdd()) return html;
      var marke = '<div class="dm-k__pd">';
      var pos = html.indexOf(marke);
      var notiz = '<p class="dm-k__notiz">' + esc(text(this, 'add_note')) + '</p>';
      if (pos === -1) return html + notiz;
      return html.slice(0, pos) + notiz + html.slice(pos);
    };

    /* ---------- Ohne Addition kein Weiterklicken ---------- */
    var pruefenAlt = P._weiterPruefen;
    P._weiterPruefen = function () {
      pruefenAlt.call(this);
      if (!this.el || !this.el.weiter || this.el.weiter.disabled) return;
      var schritt = this._schritte()[this.schrittIndex];
      if (schritt !== 'werte') return;
      var a = this.auswahl;
      if (a.methode !== 'eingabe' || !this._brauchtAdd()) return;
      var links = a.gleich ? a.rechts : a.links;
      if (a.rechts.add == null || links.add == null) this.el.weiter.disabled = true;
    };

    /* ---------- Zusammenfassung im Schubfach ---------- */
    var augeTextAlt = P._augeText;
    P._augeText = function (seite) {
      var s = augeTextAlt.call(this, seite);
      if (s === '—' || !this._brauchtAdd()) return s;
      var w = (seite === 'links' && this.auswahl.gleich) ? this.auswahl.rechts : this.auswahl[seite];
      if (!w || w.add == null) return s;
      return s + ' · Add ' + dioptrie(w.add);
    };

    /* ---------- Eigene Zeile auf der Bestellung ----------------
       Die Augenzeilen behalten ihr gewohntes Format
       \"sph | zyl | xachse\"; die Addition bekommt eine eigene
       Zeile in derselben Schreibweise wie die PD. */
    P._addAlt = function () {
      var a = this.auswahl;
      if (!this._brauchtAdd()) return '';
      var r = a.rechts.add;
      var l = (a.gleich ? a.rechts : a.links).add;
      if (r == null && l == null) return '';
      return 'OD - ' + (r == null ? '-' : altZahl(r)) +
             ' | OS - ' + (l == null ? '-' : altZahl(l));
    };

    var rezeptAlt = P._rezeptFelder;
    P._rezeptFelder = function () {
      var f = rezeptAlt.call(this);
      var add = this._addAlt();
      if (!add) return f;
      var beschriftung = text(this, 'p_add');
      /* Direkt vor die PD-Zeile, sonst ans Ende. */
      var pdName = (this.t && this.t.p_pd) || 'PD';
      for (var i = 0; i < f.length; i++) {
        if (f[i][0] === pdName) {
          f.splice(i, 0, [beschriftung, add]);
          return f;
        }
      }
      f.push([beschriftung, add]);
      return f;
    };

    /* ---------- Unuebersetzte Werkstattzeile ---------- */
    var werkstattAlt = P._werkstattWerte;
    P._werkstattWerte = function () {
      var s = werkstattAlt.call(this);
      var a = this.auswahl;
      if (a.methode !== 'eingabe' || !this._brauchtAdd()) return s;
      var links = a.gleich ? a.rechts : a.links;
      if (a.rechts.add == null && links.add == null) return s;
      return s + '   ADD ' +
        (a.rechts.add == null ? '-' : Number(a.rechts.add).toFixed(2)) + ' / ' +
        (links.add == null ? '-' : Number(links.add).toFixed(2));
    };
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('dm-konfigurator').then(function () {
      patchen(customElements.get('dm-konfigurator'));
    })['catch'](function () { /* Element gibt es auf dieser Seite nicht */ });
  }
})();
